import CompraBuscaAvacadaModal from './CompraBuscaAvancadaModal';

export default CompraBuscaAvacadaModal;
